import { useIsEmbedPageIssueView } from '@atlassian/jira-issue-context-service/src/index.tsx';
import {
	tenantHasActiveProductDiscoveryLicenseSelector,
	hasActivatedConfluenceWithinThirtyDaysSelector,
} from '@atlassian/jira-issue-view-store/src/common/state/selectors/context-selector.tsx';
import { useSelector } from '@atlassian/jira-react-redux/src/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useIsOrgAdmin } from '@atlassian/jira-business-goal-picker/src/services/is-org-admin/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

const UNSTARTED_STATUS_CATEGORY_ID = 2;
const EPIC_ISSUE_TYPE_LEVEL = 1;

interface EligibilityData {
	issueType: {
		name?: string | null;
		level?: number | null;
	};
	statusCategoryId?: string | null;
	canLinkIssues?: boolean | null;
}

export const useCrossflowIdeaCardEligible = (data?: EligibilityData): boolean => {
	const { licensedProducts } = useTenantContext();
	const isAdmin = useIsAdmin();
	const { isOrgAdmin } = useIsOrgAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const isEmbedded = useIsEmbedPageIssueView();
	const tenantHasActiveJpdLicense: boolean = useSelector(
		tenantHasActiveProductDiscoveryLicenseSelector,
	);
	const tenantHasActivatedConfluenceWithin30Days = useSelector(
		hasActivatedConfluenceWithinThirtyDaysSelector,
	);
	const tenantHasConfluence = licensedProducts?.confluence === true;

	if (!data) {
		return false;
	}

	const { issueType, statusCategoryId, canLinkIssues } = data;
	const isEpic = issueType.level === EPIC_ISSUE_TYPE_LEVEL;

	const shouldShow =
		isEpic &&
		Number(statusCategoryId) === UNSTARTED_STATUS_CATEGORY_ID &&
		canLinkIssues &&
		isAdmin &&
		(isOrgAdmin || isSiteAdmin) &&
		!isEmbedded &&
		!tenantHasActiveJpdLicense &&
		!tenantHasActivatedConfluenceWithin30Days &&
		tenantHasConfluence;

	return !!shouldShow;
};
